<template>
    <div v-if="loaded">
        <design-2021-rating-edit-title-component :rating-in="ratingIn"
                                                 :group-id="groupIn.id">
        </design-2021-rating-edit-title-component>

        <div class="assignment-edit-content">
            <div class="row" v-if="rating">
                <div class="col-12 col-md-4 col-xl-3 assignment-edit-sidebar-menu">
                    <design-2021-rating-edit-sub-nav-component :rating-in="rating"
                                                               :group-in="groupIn"
                                                               @selected-rating-section="changeSelectedSection($event)">
                    </design-2021-rating-edit-sub-nav-component>
                </div>
                <div class="col-12 col-md-8 col-xl-9" v-if="selectedSection">
                    <design-2021-rating-edit-section-component
                        :section-in="selectedSection"
                        :rating-in="rating"
                        ref="rating-list-container">
                    </design-2021-rating-edit-section-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {CommonBus, ords} from "../../app";

export default {
    name: "design-2021-rating-edit-component",
    props:{
        ratingIn: {
            type: Object,
            require: true,
        },
        groupIn: {
            type: Object,
            require: true,
        },
    },

    data(){
        return{
            loaded: false,
            rating: {},
            selectedSectionId: null,
        }
    },
    computed: {
        selectedSection() {
            if(this.rating.sections){

                if(this.selectedSectionId === null){
                    if(this.rating.sections.length !== 0){
                        this.selectedSectionId = this.rating.sections[0].id;
                    }
                }

                for(const section of this.rating.sections){
                    if (section.id === this.selectedSectionId) {
                        return section;
                    }
                }

                return this.rating.sections[0];
            }

            return null;
        }
    },
    methods:{
        changeSelectedSection(id) {
            this.selectedSectionId = id;
        },
    },

    mounted() {
        if(!this.loaded){
            ords.use('rating').add(this.ratingIn)

            ords.use('rating')
                .with('sections', (sectionsCallback) => {
                    sectionsCallback.with('items', (itemsCallback) =>{
                        itemsCallback.with('options')
                        itemsCallback.orderBy('order')
                    })
                    sectionsCallback.orderBy('order')
                })
                .find(this.ratingIn.id)
                .subscribe((rating) => {
                    this.rating = rating;
                })

            this.loaded = true;
        }
    },
    created() {
        CommonBus.$on('scroll-to-item', (itemId) => {
            const mainContainer = document.getElementsByClassName('main-content');

            Vue.nextTick(()=>{
                const element = document.getElementsByClassName(`page-container-item-${itemId}`);
                $('.main-content').animate({ scrollTop: element[0].offsetTop,}, 500);
            })
        });
    },
}
</script>

<style scoped lang="scss">
    .sub-assignment-drag-handle {
        color: lightgray;
        margin-right: 15px;
    }
    .sub-assignment-drag-handle:hover {
        color: black;
    }

    .list-group-item{
        border: none;
        font-size: 0.875rem;
    }

    .list-group-item:hover,
    .list-group-item.active {
        background-color: #e8eff4bf;
        color: #212529;
    }

    .edit-assignments .header{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        margin-bottom: 21px;
        flex-direction: column;
    }

    .edit-assignments .header > .actions {
        align-self: flex-end;
    }

    .sub-assignments-edit-nav {
        margin-bottom: 60px;
    }


    @media (min-width: 768px) {

        .sub-assignments-edit-nav {
            margin-bottom: 0px;
        }

        .edit-assignments .header{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 21px;
            flex-direction: row;
        }

        .edit-assignments .header > .actions {
            align-self: baseline;
        }
    }
</style>
